import { ListingArticoliTemplate, ListingSettimaneTemplate } from '@components/templates'
import { initializeApollo } from '@gql/client'
import { CATEGORIA, CATEGORIE } from 'utils/queries'
import { TIPO_1, TIPO_2 } from 'utils/settings'
import { CategoriaType } from 'utils/types'
import { api as pagebuilderApi } from 'react-pagebuilder/services/api'
import { NextWrapper } from 'data-fetching-wrapper'

interface Props {
  categoria: CategoriaType
  defaultContent?: any
}

function CategoriaDetail({ categoria, defaultContent }: Props) {
  return categoria.tipo === TIPO_2 ? (
    <ListingSettimaneTemplate
      pagina={categoria.pagina}
      categoria={categoria}
      defaultContent={defaultContent}
    />
  ) : (
    <ListingArticoliTemplate
      pagina={categoria.pagina}
      categoria={categoria}
      mainArticolo={categoria.tipo === TIPO_1}
    />
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(async () => {
  const client = initializeApollo()

  const {
    data: { categorie },
  } = await client.query({
    query: CATEGORIE,
  })

  const paths = categorie.edges.map((x) => ({
    params: { slug: x.node.url.split('/').slice(2) },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}, '/c/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData }) => {
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const client = initializeApollo()

    const {
      data: { categoria },
    } = await client.query({
      query: CATEGORIA,
      variables: { slugTree: slug.join('/') },
      context: {
        headers,
      },
    })

    if (!categoria) {
      return {
        notFound: true,
      }
    }

    let defaultContent = null
    if (categoria.tipo === TIPO_2) {
      try {
        defaultContent = await pagebuilderApi.getPagebuilder({
          contentTypeId: categoria.model,
          objectId: categoria.pk,
          key: 'content',
          edit_mode: false,
        })
      } catch (err) {
        console.log(err)
      }
    }

    return {
      props: { categoria, key: categoria.pk, defaultContent },
      revalidate: 60 * 2,
    }
  },
  '/c/[slug]'
)

export default CategoriaDetail
